import React, { SVGProps } from 'react'
const SvgGreyExtendSparkle = (
  props: SVGProps<SVGSVGElement>,
): React.ReactElement => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    fill="none"
    aria-hidden="true"
    {...props}
  >
    <g clipPath="url(#Grey-Extend-Sparkle_svg__a)">
      <path
        fill={props.fill || '#697080'}
        fillRule="evenodd"
        d="M5 2.667c.368 0 .667.298.667.666v1h1a.667.667 0 0 1 0 1.334h-1v1a.667.667 0 0 1-1.334 0v-1h-1a.667.667 0 0 1 0-1.334h1v-1c0-.368.299-.666.667-.666m5.667.666c.276 0 .523.17.622.428l1.156 3.006c.2.52.263.67.35.791q.13.184.313.314c.121.087.271.15.792.35l3.006 1.156a.667.667 0 0 1 0 1.244L13.9 11.778c-.52.2-.67.264-.792.35a1.3 1.3 0 0 0-.314.314c-.086.12-.149.27-.349.791L11.29 16.24a.667.667 0 0 1-1.245 0l-1.156-3.006c-.2-.52-.263-.67-.349-.791a1.3 1.3 0 0 0-.314-.314c-.12-.086-.271-.15-.792-.35l-3.006-1.156a.667.667 0 0 1 0-1.244l3.006-1.156c.521-.2.671-.263.792-.35q.184-.13.314-.314c.086-.12.15-.27.35-.791l1.156-3.006a.67.67 0 0 1 .622-.428m0 2.524-.534 1.388-.026.068c-.163.423-.285.743-.481 1.018a2.7 2.7 0 0 1-.628.628c-.276.196-.595.319-1.018.481l-.068.026L6.524 10l1.388.534.068.026c.423.162.742.285 1.018.481.243.173.455.385.628.628.196.275.318.595.48 1.018q.014.033.027.068l.534 1.388.534-1.388.026-.068c.162-.423.285-.742.48-1.018.173-.243.386-.455.629-.628.275-.196.595-.319 1.018-.48q.033-.014.068-.027L14.81 10l-1.389-.534-.067-.026c-.423-.162-.743-.285-1.018-.48a2.7 2.7 0 0 1-.628-.629c-.196-.275-.319-.595-.481-1.018l-.026-.068zM5 12.667c.368 0 .667.298.667.666v1h1a.667.667 0 0 1 0 1.334h-1v1a.667.667 0 1 1-1.334 0v-1h-1a.667.667 0 1 1 0-1.334h1v-1c0-.368.299-.666.667-.666"
        clipRule="evenodd"
      />
    </g>
    <defs>
      <clipPath id="Grey-Extend-Sparkle_svg__a">
        <path fill="#fff" d="M2 2h16v16H2z" />
      </clipPath>
    </defs>
  </svg>
)
export default SvgGreyExtendSparkle
